import React from "react";
import { Switch as MatSwitch } from "@material-ui/core";

const Switch = (props) => {
  return <MatSwitch color="primary" checked={props.checked} onChange={props.onChange} />;
};

export default Switch;
